<template>
  <transition name="fade">
    <div v-if="profileInfo && Object.keys(profileInfo).length > 0" class="section">
      <div class="section-title">
        Your Profile
      </div>
      <div class="section-body">
        <div class="profile-picture">
          <img
            class="lazyload"
            :src="defaultProfilePicture"
            :data-src="profileInfo.profileImageUrl"
          >
        </div>
        <div class="profile-name">
          {{ profileInfo.firstName }}
        </div>
        <div class="profile-score">
          <span style="font-weight: bold">{{ profileInfo.score }}</span> total points
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
const defaultProfilePicture = require('@/assets/default-profile-picture.jpg');

export default Vue.extend({
  name: 'ProfileComponent',
  data: () => ({
    profileInfo: {},
    defaultProfilePicture
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async getProfileInfo() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/getprofileinfoforuser`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });

      this.profileInfo = response.data.profileInfo;
    }
  },
  created: async function() {
    try {
      await this.getProfileInfo();
    } catch (error) {
      console.log('Error:', error);
    }
  }
})
</script>

<style scoped lang="scss">
.section {
  min-height: min-content;
  width: 100%;
  color: $dark-brown;
  padding: 0.4em 0.8em;
}

.section-title {
  font-size: 1.4em;
  font-weight: bold;
  padding: 0.4em 0.8em;
}

.section-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 16em;
  background-color: white;
  border: 0.1em solid $dark-sand;
  border-radius: 0.6em;
  padding: 0.4em 0.8em;
}

.profile-picture {
  height: 7em;
  width: 7em;
  margin: auto 0;
  border-radius: 50%;
  overflow: hidden;
}

.profile-picture > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.profile-name {
  padding: 0.5em 0;
  font-size: 1.1em;
}

.profile-score {
  padding: 0.5em 0;
}
</style>
